import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import { ContentService } from '../../services/aem/content.service';
import * as AEMActions from '../actions/content.actions';

@Injectable()
export class ContentEffects {
  loadContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AEMActions.loadAEMContent),
      switchMap(() =>
        this.content.getContent().pipe(
          map((content) =>
            AEMActions.loadAEMContentSuccess({
              aemContent: {
                id: 'aem-content',
                aemContent: content
              }
            })
          ),
          catchError(() =>
            of(
              AEMActions.loadAEMContentFailure({
                aemContentError: {
                  id: 'aem-content-error',
                  aemContentError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );

  loadFeatureFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AEMActions.loadAEMFeatureFlags),
      switchMap(() =>
        this.content.getFeatureFlags().pipe(
          map((content) =>
            AEMActions.loadAEMFeatureFlagsSuccess({
              aemFeatureFlags: {
                id: 'aem-feature-flags',
                aemFeatureFlags: content
              }
            })
          ),
          catchError(() =>
            of(
              AEMActions.loadAEMFeatureFlagsFailure({
                aemFeatureFlagsError: {
                  id: 'aem-feature-flags-error',
                  aemFeatureFlagsError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );

  loadWelcomeTour$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AEMActions.loadAEMWelcomeTour),
      switchMap(() =>
        this.overview.flags$.pipe(
          filter((flag) => !!flag?.welcomeTour),
          switchMap(() =>
            this.content.getWelcomeTour().pipe(
              map((content) =>
                AEMActions.loadAEMWelcomeTourSuccess({
                  aemWelcomeTour: {
                    id: 'aem-welcome-tour',
                    aemWelcomeTour: content
                  }
                })
              ),
              catchError(() =>
                of(
                  AEMActions.loadAEMWelcomeTourFailure({
                    aemWelcomeTourError: {
                      id: 'aem-welcome-tour-error',
                      aemWelcomeTourError: 'full-page'
                    }
                  })
                )
              )
            )
          )
        )
      )
    )
  );

  loadErrorMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AEMActions.loadAEMErrorMessages),
      switchMap(() =>
        this.content.getErrorMessages().pipe(
          map((content) =>
            AEMActions.loadAEMErrorMessagesSuccess({
              aemErrorMessages: {
                id: 'aem-error-messages',
                aemErrorMessages: content.errorMessagesSection.errormessages
              }
            })
          ),
          catchError(() =>
            of(
              AEMActions.loadAEMErrorMessagesFailure({
                aemErrorMessagesError: {
                  id: 'aem-error-messages-error',
                  aemErrorMessagesError: 'full-page'
                }
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly content: ContentService,
    private readonly overview: OverviewFacade
  ) {}
}
